
import {Utils} from "../utils.js";

// The single scaling function every digitization visual (vertices, computed/
// ghost points, connector markers, labels - across every tool, not just
// Midline) uses to keep its on-screen size constant in pixels, regardless of
// camera type (perspective/orthographic - both handled by the underlying
// Utils.projectedRadius, the same primitive Potree's own Measure/Volume
// tools use), zoom, or distance.
//
// Geometry conventions: every digitization mesh (sphere/octahedron marker)
// is built at world-space radius 1, so `targetPixels` here is a real,
// literal pixel count - not an approximate legacy constant.
//
// Defensively clamped: a bad frame (camera exactly on top of the point,
// a transient NaN/Infinity from projection math, etc.) can never balloon a
// marker or label to dominate the screen - it just shrinks to near-nothing
// instead.
const MIN_SCALE = 1e-4;
const MAX_SCALE = 1e6;

export function computeScreenSpaceScale(camera, worldPosition, cameraPosition, clientWidth, clientHeight, targetPixels){
	if(!camera || !worldPosition || !cameraPosition) return MIN_SCALE;
	if(!(clientWidth > 0) || !(clientHeight > 0)) return MIN_SCALE;

	const distance = cameraPosition.distanceTo(worldPosition);
	if(!isFinite(distance) || distance <= 0) return MIN_SCALE;

	const pr = Utils.projectedRadius(1, camera, distance, clientWidth, clientHeight);
	if(!isFinite(pr) || pr <= 1e-9) return MIN_SCALE;

	let scale = targetPixels / pr;
	if(!isFinite(scale) || scale <= 0) return MIN_SCALE;

	return Math.min(Math.max(scale, MIN_SCALE), MAX_SCALE);
}

// recommended pixel targets (may be tuned later, kept in one place so every
// tool stays consistent when they are). Markers are built at world-space
// radius 1, so their targets are literal pixels. Labels are TextSprites
// whose own base geometry isn't radius-1 (it's derived from the rendered
// text's canvas size) - "70" is the proven scale factor already used
// throughout Potree's own measurement labels for a readable, constant
// on-screen size; the actual *text* size is controlled by fontsize
// (~11-12px, see DigitizationStyle.js) rather than by this constant.
export const ScreenSpaceSizes = {
	vertex: 6,
	vertexHover: 8,
	computedPoint: 7,
	label: 70,
	insertHandle: 9,
	copyIcon: 8,
	// small chevrons showing a LineString's run direction (first→last vertex);
	// deliberately below the vertex size so the geometry keeps dominating
	directionChevron: 7,
};
